import { AxiosResponseHeaders } from 'axios';
import { removeDuplicatesByNestedProps } from '../../../../../content-composer/src/utils';
import { PartyIdentification } from '../../../../../card/src/types';
import { PartyRole } from '../../../../../transaction/src/contexts/Parameters/types';
import { CardHeaders, PostLoginCardResponseDTO } from '../entities';
import { PartyRelationship } from '../entities/PostLoginCardResponseDTO';

const postLoginCardResponseDTOtoPostLoginCardAdapter = (
  response: PostLoginCardResponseDTO,
  headers?: AxiosResponseHeaders,
): {
  cardHeaders: CardHeaders;
  selectedPartyIdentification?: PartyIdentification;
  partyRelationships?: PartyRelationship[];
  partyRoles?: PartyRole[];
} => {
  if (!response.body) {
    throw Error();
  }

  return {
    cardHeaders: { 'x-auth-token': headers?.['x-auth-token'] },
    selectedPartyIdentification: response.body.partyIdentifications.find(
      party => party.type === 'CoreBankingIdentifier',
    ),
    partyRelationships: removeDuplicatesByNestedProps(response.body.partyRelationships, [
      'partyIdentifications',
      '0',
      'identifier',
      'value',
    ]) as PartyRelationship[],
    partyRoles: response.body.partyRoles,
  };
};

export { postLoginCardResponseDTOtoPostLoginCardAdapter };
